import React from 'react';
import { ROOM_NEED_AUDIT, CHINESE, ENGLISH } from '../../utils/constants';
import leftEnaImg from '../../assets/icon-left-enable.svg';
import leftDisImg from '../../assets/icon-left-disable.svg';
import rightEnaImg from '../../assets/icon-right-enable.svg';
import rightDisImg from '../../assets/icon-right-disable.svg';
import { FormattedMessage } from 'react-intl';
import {getSignTypeKey} from "../../utils/meetingUtil";

class RoomDetailPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: true, room: {}, start: 0 };
  }

  render() {
    const {room} = this.props;
    const {audit, zoneFullName, minNumber, maxNumber, rates, capacityStr, adminUserName, sign, logo, deviceList} = room;
    const { intl, locale } = this.props;

    const signAudit = [];
    signAudit.push(<span key={1}>
      {intl.formatMessage({id: getSignTypeKey(String(sign))})}
    </span>)
    if (audit === ROOM_NEED_AUDIT.yes) {
      signAudit.push(<span key={2}>&nbsp;|&nbsp;</span>)
      signAudit.push(<FormattedMessage key={3} id="need_audit" />)
    }

    const deviceNames = [];
    const nameEllipsis = {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    };
    deviceList && deviceList.forEach((d, i)=>{
      const {state, device: {name, nameEn}} = d;
      deviceNames.push(
        <span key={`${i}_device`} style={{...nameEllipsis, color: `${state>0?'#FF0000':'#000000'}`}}>
          {locale===ENGLISH?nameEn:name}
        </span>
      )
      deviceNames.push(
        <span key={`${i}_separator`}>&nbsp;|&nbsp;</span>
      )
    });
    deviceNames.pop();

    let logos = logo ? logo.split(';') : [];
    return (
      <div className="room-content">
        <div className="room-item">
          <label className="title">
            {intl.formatMessage({ id: 'room_edit_belong_area' })} :
          </label>
          <span className="co-area">{zoneFullName}</span>
        </div>
        <div className="room-item">
          <label className="title">
            {intl.formatMessage({ id: 'room_edit_people_number' })} :
          </label>
          <span className="co-area">
            {minNumber + '-' + maxNumber + " " + intl.formatMessage({ id: 'meeting_sing_label_unit_people' })}
          </span>
        </div>
        <div className="room-item">
          <label className="title">
            {intl.formatMessage({ id: 'room_edit_cost' })} :
          </label>
          <span className="co-area">
           {(rates && parseFloat(rates) > 0 ? '￥'+ rates.toFixed(2)+" / h" : intl.formatMessage({id:"price_free"})) }
          </span>
        </div>
        <div className="room-item">
          <label className="title">
            {intl.formatMessage({ id: 'room_detail_room_type' })} :
          </label>
          <span className="co-area">{capacityStr || ''}</span>
        </div>
        <div className="room-item">
          <label className="title">
            {intl.formatMessage({ id: 'room_edit_sign_type' })} :
          </label>
          <span className="co-area">{signAudit}</span>
        </div>
        <div className="room-item">
          <label className="title">
            {intl.formatMessage({ id: 'room_edit_room_manage' })} :
          </label>
          <span className="co-area">{adminUserName}</span>
        </div>
        <div className="room-item">
          <label className="title">
            {intl.formatMessage({ id: 'room_edit_fixed_device' })} :
          </label>
          <span className="co-area">{deviceNames}</span>
        </div>
        <div className="room-item">
          <label className="title" style={{ float: 'left' }}>
            {intl.formatMessage({ id: 'room_edit_room_image' })} :
          </label>
          <span className="co-area" style={{ marginLeft: 0 }}>
            {logos.length > 1 ? (
              <span className="prefix">
                <img
                  src={this.state.start <= 0 ? leftDisImg : leftEnaImg}
                  className={this.state.start <= 0 ? 'btn-dis' : ''}
                  onClick={() => {
                    let startIndex = this.state.start;
                    if (startIndex > 0) {
                      this.setState({ start: startIndex - 1 });
                    }
                  }}
                />
              </span>
            ) : (
              <span className="blank" />
            )}
            <span className="logo-area">
              <img className="logo" src={logos[this.state.start] || ''} />
            </span>
            {logos.length > 1 ? (
              <span className="next">
                <img
                  src={
                    this.state.start + 1 >= logos.length
                      ? rightDisImg
                      : rightEnaImg
                  }
                  className={
                    this.state.start + 1 >= logos.length ? 'btn-dis' : ''
                  }
                  onClick={() => {
                    let startIndex = this.state.start;
                    if (startIndex + 1 < logos.length) {
                      this.setState({ start: startIndex + 1 });
                    }
                  }}
                />
              </span>
            ) : null}
          </span>
        </div>
      </div>
    );
  }
}

export default RoomDetailPopover;



// WEBPACK FOOTER //
// ./src/components/commons/RoomDetailDialog.js